import { faker } from '@faker-js/faker'

import { getAdminTreatmentItemOfOption } from './TreatmentItemOfOption'
import { getPrice } from './Price'

import { DiscountEligibility, ServiceOfferOption, ServiceOfferOptionBadge } from '../../contracts/service-offer'
import { asBuilder } from '../asBuilder'

export const getServiceOfferOption = asBuilder((): ServiceOfferOption => {
  const { currency, ...priceWithoutCurrency } = getPrice()

  return {
    id: faker.string.uuid(),
    name: faker.string.uuid(),
    price: priceWithoutCurrency,
    treatments: {
      items: faker.helpers.multiple(getAdminTreatmentItemOfOption),
    },
    badges: faker.helpers.multiple(() => faker.helpers.enumValue(ServiceOfferOptionBadge), {
      count: {
        min: 1,
        max: 4,
      },
    }),
    pricePolicy: {
      discountCondition: {
        discountEligibility: faker.helpers.multiple(() => faker.helpers.enumValue(DiscountEligibility)),
        promotionalUseDiscount: {
          available: faker.datatype.boolean(),
          description: faker.lorem.sentence(),
        },
      },
    },
  }
})
